module.exports = __webpack_public_path__ + "bcb96221.svg";